export const BORDER_TYPE = {
  NO_BORDER: {
    name: 'No border',
    value: 'noBorder'
  },
  LINE: {
    name: 'Line',
    value: 'line'
  }
};

export const BORDER_TYPES = [BORDER_TYPE.NO_BORDER, BORDER_TYPE.LINE];
